import { render, staticRenderFns } from "./tutor-project.vue?vue&type=template&id=1ff8decb&scoped=true&"
import script from "./tutor-project.vue?vue&type=script&lang=js&"
export * from "./tutor-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8decb",
  null
  
)

export default component.exports